module.exports = __webpack_public_path__ + "static/media/Configurazione_Base.4d9c1cd1.mp4";